import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { pagePath } from '../utils/consts/pagePath';

const TodoPage = lazy(() => import('../../view/pages/TodoPage'));

export const todoRoutes: RouteObject = {
  path: pagePath.todo.list,
  children: [
    {
      index: true,
      element: <TodoPage />,
    },
  ],
};
